module.exports = __webpack_public_path__ + "static/6-9fd531299d356573dc7d9f80fd848473.jpeg";